import { graphql } from '@/generated/gql';

export const INTAKE_REQUIREMENTS_UPLOAD_MUTATION = graphql(/* GraphQL */ `
  mutation IntakeRequirementsUploadMutation($data: SvbrgRequirementsExtractionUpsertInput!) {
    sevenbridges {
      chatSession {
        requirementsExtraction {
          uploadDcoument(data: $data) {
            id
            chatSessionId
            fileIds
            processingStatus
            extractedData
            enhancedData
            errorMessage
          }
        }
      }
    }
  }
`);

export const INTAKE_REQUIREMENTS_SKIP_MUTATION = graphql(/* GraphQL */ `
  mutation IntakeRequirementsSkipMutation($data: SvbrgRequirementsExtractionSkipInput!) {
    sevenbridges {
      chatSession {
        requirementsExtraction {
          skip(data: $data) {
            id
            chatSessionId
            processingStatus
          }
        }
      }
    }
  }
`);

export const INTAKE_REQUIREMENTS_NEXT_MUTATION = graphql(/* GraphQL */ `
  mutation IntakeRequirementsNextMutation($data: SvbrgRequirementsExtractionNextInput!) {
    sevenbridges {
      chatSession {
        requirementsExtraction {
          next(data: $data) {
            id
            chatSessionId
            processingStatus
          }
        }
      }
    }
  }
`);
